
document.addEventListener('DOMContentLoaded', () => {

  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
    const sectionId = data.event.target.closest('.section').id.replace('shopify-section-', '');
    const gallery = document.querySelector(`media-gallery#MediaGallery-${sectionId}`);
    const jsonBrain = document.getElementById(`ProductGallery-Metaobjects-${sectionId}`);
    
    if (!gallery || !jsonBrain) return;

    const config = JSON.parse(jsonBrain.textContent);
    

    const selectedOptions = Array.from(document.querySelectorAll(`[data-section="${sectionId}"] .product-form__input`))
      .map(input => {
        const selected = input.querySelector('input:checked, select option:selected, select');
        const val = selected.value || selected.getAttribute('value');
        return val.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
      });

    const mattressKey = `${selectedOptions[0]}_${selectedOptions[1]}`;
    const drawerKey = `${selectedOptions[0]}_${selectedOptions[1]}_${selectedOptions[2]}`;
    const bedKey = selectedOptions[0];

    let match = config.mattress[mattressKey] || config.drawer_base[drawerKey] || config.bed_base[bedKey];

    if (match && match.images.length > 0) {
      updateHyperGallery(gallery, match.images);
    }
  });

  function updateHyperGallery(galleryElement, imageUrls) {
    const mainWrapper = galleryElement.querySelector('.product__media-list');
    const thumbWrapper = galleryElement.querySelector('.thumbnail-list');
    
    if (!mainWrapper) return;

    // Clear existing slides
    mainWrapper.innerHTML = '';
    if (thumbWrapper) thumbWrapper.innerHTML = '';

    imageUrls.forEach((url, index) => {
      // Build Main Slide
      const slide = document.createElement('div');
      slide.className = 'product__media-item swiper-slide';
      slide.innerHTML = `<div class="media-wrapper blocks-radius" style="--aspect-ratio: 1">
        <img src="${url}" loading="${index === 0 ? 'eager' : 'lazy'}" class="image-lazy">
      </div>`;
      mainWrapper.appendChild(slide);

      // Build Thumbnail
      if (thumbWrapper) {
        const thumb = document.createElement('div');
        thumb.className = 'product__thumbs-item swiper-slide';
        thumb.innerHTML = `<div class="product__thumbs-container relative blocks-radius-md media-wrapper">
          <div class="product__thumbs-inner" style="--aspect-ratio: 1">
            <img src="${url}&width=150" loading="lazy">
          </div>
        </div>`;
        thumbWrapper.appendChild(thumb);
      }
    });

    const mattressKey = `${selectedOptions[0]}_${selectedOptions[1]}`;
        console.log('Looking for Mattress Key:', mattressKey);
        console.log('Available Mattress Keys:', Object.keys(config.mattress));
        
        let match = config.mattress[mattressKey] || config.drawer_base[drawerKey] || config.bed_base[bedKey]; 
    window.dispatchEvent(new Event('resize'));
    

    if (galleryElement.slider) galleryElement.slider.update();
    if (galleryElement.thumbnailSlider) galleryElement.thumbnailSlider.update();
  }
});

